export interface CreateAuthorityRequest {
  authorityType: string
  authorities: {
    tag: string
    data: string
  }[]
}

export function CreateAuthorityRequestToJSON(
  value: CreateAuthorityRequest
): any {
  return {
    authority_type:
      value.authorityType !== '' ? value.authorityType : undefined,
    authorities:
      value.authorities.length > 0
        ? value.authorities.map(authority => {
            return {
              tag: authority.tag !== '' ? authority.tag : undefined,
              data: authority.data !== '' ? authority.data : undefined
            }
          })
        : []
  }
}
